import { withAbortListener } from "./abort";
import { Condition } from "./condition";
import { Queue } from "./queue";

export class WaitQueue<T> implements AsyncIterable<T> {
  readonly #waiters = new Queue<Condition<T>>();

  release(value: T): void {
    if (this.#waiters.empty()) {
      return;
    }
    this.#waiters.pop().resolve(value);
  }

  wait(signal?: AbortSignal): Promise<T> {
    const waiter = new Condition<T>();
    const remove = this.#waiters.push(waiter);
    const result = waiter.result;
    if (signal) {
      return withAbortListener(signal, (reason) => {
        remove();
        waiter.reject(reason);
      })(() => result);
    }
    return result;
  }

  async *[Symbol.asyncIterator]() {
    while (true) {
      yield await this.wait();
    }
  }
}
